import React from "react";
import Icon from "theme/Icon";
import Image from "theme/Image";
import Selectbox from "theme/Selectbox";
import Button from "theme/Button";
import { objectSelector, thumbnailImageUrl, currencyText } from "theme/utils";

import $B from "plugins/tfs/platformConfigs/integrationMaps/basket";
import $BT from "plugins/tfs/platformConfigs/theme/basket.json";

import { GIFT_CARD_SKU_LIST } from "../../product/detail/constants";

export default function BasketItem(props) {
  const { item } = props;

  const quantity =
    item.product.stock <= $BT.MAX_QUANTITY_OPTION
      ? item.product.stock
      : $BT.MAX_QUANTITY_OPTION;

  // Generates quantity options between 1 to $BT.MAX_QUANTITY_OPTION
  const quantityOptions = Array.from({ length: quantity }, (_, i) => ({
    label: (i + 1).toString(),
    value: (i + 1).toString(),
  }));

  const imageUrl =
    item.product.productimage_set.length &&
    item.product.productimage_set[0].image;

  return (
    <div className="item">
      <div className="item__imageWrapper">
        <Image
          src={thumbnailImageUrl(imageUrl, 80, 80, 90)}
          width={80}
          height={80}
        />
      </div>
      <div className="item__contentWrapper">
        <div className="column metaWrapper">
          <p className="product__name product__margin">{item.product.name}</p>
          <p className="product__base_code product__margin">
            {item.product.base_code}
          </p>
          {Object.keys(item.product.attributes).map((key) =>
            $B.ATTRIBUTES.map(
              (attr, i) =>
                key === attr.key && (
                  <p key={i} className="product__attributes product__margin">
                    {objectSelector(item, attr.label) !== undefined
                      ? `${attr.title}: ${objectSelector(item, attr.label)}`
                      : ""}
                  </p>
                )
            )
          )}
        </div>
        <div className="column optionWrapper">
          <div>
            {item.product.retail_price !== item.product.price && (
              <p className="retail-price">
                {item.product.retail_price}
                {currencyText(item.currency_type)}
              </p>
            )}
            <p className="price">
              {item.product.price}
              {currencyText(item.currency_type)}
            </p>
          </div>
          {GIFT_CARD_SKU_LIST.includes(item.product.sku) ? (
            <React.Fragment></React.Fragment>
          ) : (
            <React.Fragment>
              <div className="cross">X</div>
              <Selectbox
                name="quantity"
                icon="oksag"
                options={[...quantityOptions]}
                value={item.quantity}
                onChange={(value) => props.onQuantity(parseInt(value, 10))}
              />
            </React.Fragment>
          )}
          <Button
            classes="remove pointer"
            onClick={() => props.onQuantity(parseInt("0", 10))}
          >
            <Icon icon="carpi" />
          </Button>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/basket/basketItem/index.js